module.exports = __webpack_public_path__ + "img/logo_capital_partners.1f24d707.svg";